export default __webpack_public_path__ + "static/media/samsung.b73775e1.png";